export function camelToSentence(str: string) {
    return str
        .replace(/([a-z])([A-Z])/g, '$1 $2')
        .toLowerCase()
        .replace(/^\w/, c => c.toUpperCase())
}
